import './Verse.css';
export default function Verse() {
    return (<section id="verse" className="hero is-halfheight">
        <div className="hero-body">
            <div className="container has-text-centered has-text-black">
                <p className="title">1 Korintus 2:9</p>
                <p className="subtitle">Tetapi seperti ada tertulis: "Apa yang tidak pernah dilihat oleh mata, dan tidak pernah didengar oleh telinga, dan yang tidak pernah timbul di dalam hati manusia: semua yang <strong>disediakan Allah</strong> untuk mereka yang <strong>mengasihi Dia</strong>.</p>
            </div>
        </div>
    </section>);
}